import DemandeInscriptionRenouvellement from '../views/DemandeInscriptionRenouvellement.vue'
import RenseignementsGeneraux from '../components/DemandeInscriptionRenouvellement/RenseignementsGeneraux.vue'
import AutorisationDePratique from '../components/DemandeInscriptionRenouvellement/AutorisationDePratique.vue'
import DeclarationsObligatoires from '../components/DemandeInscriptionRenouvellement/DeclarationsObligatoires.vue'
import AttestationVeracite from '../components/DemandeInscriptionRenouvellement/AttestationVeracite.vue'
import TransmissionOrdre from '../components/DemandeInscriptionRenouvellement/TransmissionOrdre.vue'
import StatutEmploiEtLieuxDeTravail from '../components/DemandeInscriptionRenouvellement/StatutEmploiEtLieuxDeTravail'
import Assurance from '../components/DemandeInscriptionRenouvellement/Assurance'
import OptionsDePaiement from '../components/DemandeInscriptionRenouvellement/OptionsDePaiement'
import ActiviteReservee from "@/components/DemandeInscriptionRenouvellement/ActiviteReservee"
import RecapitulatifPaiement from '../components/DemandeInscriptionRenouvellement/RecapitulatifPaiement.vue'

const routeName = "DemandeInscriptionRenouvellement"

export default [
  {
    path: '/demande-inscription/renouvellement',
    name: 'DemandeInscription/Renouvellement',
    component: DemandeInscriptionRenouvellement,
    props: {
      routeName: routeName
    },
    children: [
      {
        path: "renseignements-generaux",
        name: `${routeName}/RenseignementsGeneraux`,
        component: RenseignementsGeneraux,
      },
      {
        path: "autorisation-de-pratique",
        name: `${routeName}/AutorisationDePratique`,
        component: AutorisationDePratique
      },
      {
        path: "statut-emploi-et-lieux-de-travail",
        name: `${routeName}/StatutEmploiEtLieuxDeTravail`,
        component: StatutEmploiEtLieuxDeTravail
      },
      {
        path: "activite-reservee",
        name: `${routeName}/ActiviteReservee`,
        component: ActiviteReservee
      },
      {
        path: "assurance",
        name: `${routeName}/Assurance`,
        component: Assurance
      },
      {
        path: "options-de-paiement",
        name: `${routeName}/OptionsDePaiement`,
        component: OptionsDePaiement
      },
      {
        path: "declarations-obligatoires",
        name: `${routeName}/DeclarationsObligatoires`,
        component: DeclarationsObligatoires
      },
      {
        path: "transmission-ordre",
        name: `${routeName}/TransmissionOrdre`,
        component: TransmissionOrdre
      },
      {
        path: "recapitulatif-paiement",
        name: `${routeName}/RecapitulatifPaiement`,
        component: RecapitulatifPaiement
      },
      {
        path: "attestation-veracite",
        name: `${routeName}/AttestationVeracite`,
        component: AttestationVeracite
      }
    ]
  },
]